import { render, staticRenderFns } from "./WorkUploadButtons.vue?vue&type=template&id=86a2c9a6"
import script from "./WorkUploadButtons.vue?vue&type=script&lang=js"
export * from "./WorkUploadButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports